import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-white text-gray-800 p-6 md:p-12">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-bold text-center text-indigo-700 mb-8">
          Terms and Conditions
        </h1>

        {/* --- BEGIN SOFTWARE AGREEMENT --- */}
        <section className="mb-8 space-y-4">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            Listernaut Software Agreement
          </h2>

          <p>
            THIS COMPUTER SERVICES AGREEMENT (the "Agreement") is dated upon
            acceptance by the Client.
          </p>

          <p>
            <strong>CLIENT</strong> (the "Client")  
            <br />
            <strong>CONTRACTOR</strong> Listernaut, LLC, 2457 East Washington St. STE D,
            Indianapolis, IN 46201, USA (the "Contractor")
          </p>

          <h3 className="text-xl font-semibold text-indigo-600">
            1. BACKGROUND
          </h3>

          <p>
            1. The Client is of the opinion that the Contractor has the necessary
            qualifications, experience and abilities to provide computer services to the
            Client.
          </p>
          <p>
            2. The Contractor is agreeable to providing such computer services on the
            terms set out in this Agreement.
          </p>

          <p>
            IN CONSIDERATION OF the mutual benefits and obligations set forth
            herein, the Parties agree as follows:
          </p>

          <h3 className="text-xl font-semibold text-indigo-600">
            2. SERVICES PROVIDED
          </h3>

          <p>The Contractor agrees to provide the Client with the following services:</p>

          <ul className="list-disc pl-6 space-y-2">
            <li>Listernaut Lite - access to account and tutorials.</li>
            <li>Listernaut Explorer - access to account and tutorials.</li>
            <li>
              Listernaut Enterprise Version - software implementation, training, and onboarding.
            </li>
            <li>
              Listernaut Managed Services - software implementation, training, and onboarding.
              Integration with client accounts such as online auction software, Shopify,
              SkuVault, Amazon, Walmart, shipping software, POS, and eBay.
            </li>
            <li className="pl-2">
              <strong>NOTE:</strong>
              <ul className="list-disc pl-4 space-y-1">
                <li>
                  All archived data will be permanently deleted after sixty (60) days to maintain speed. DO NOT archive catalogs you intend to keep.
                </li>
                <li>
                  The Client acknowledges that active (non-archived) catalogs that remain open for more than sixty (60) days are subject to a recurring storage and maintenance fee of one (1) Listernaut token per catalog per calendar month, assessed on or about the first day of each month, until such catalog is archived or deleted. Catalogs that are subject to this monthly charge will be identified within the Listernaut user interface (for example, by an asterisk or other comparable visual indicator). In the event the Client’s token balance is zero (0) at the time a monthly assessment would otherwise occur, the Client will have until the next monthly assessment date to purchase additional tokens. If, following such additional monthly period, the Client’s token balance remains at zero (0) and the applicable catalog is at least one hundred eighty (180) days old, the Contractor may, in its sole discretion, permanently delete the catalog and all associated data, and such data will not be recoverable.
                </li>
              </ul>
            </li>
          </ul>

          <p>
            The Services will also include any additional tasks mutually agreed to by both
            Parties.
          </p>

          <h3 className="text-xl font-semibold text-indigo-600">
            3. TERM OF AGREEMENT
          </h3>

          <p>
            1. The Term begins upon acceptance and continues indefinitely until terminated.
          </p>
          <p>
            2. Either Party may terminate with 30 days’ written notice.
          </p>
          <p>
            3. A material breach allows the non-defaulting Party to terminate immediately
            and seek damages.
          </p>
          <p>4. Mutual termination is allowed at any time.</p>
          <p>5. Contractor obligations end upon termination unless otherwise stated.</p>

          <h3 className="text-xl font-semibold text-indigo-600">
            4. PERFORMANCE
          </h3>
          <p>Both Parties agree to take all steps necessary to fulfill this Agreement.</p>

          <h3 className="text-xl font-semibold text-indigo-600">
            5. CURRENCY
          </h3>
          <p>All monetary amounts are in USD.</p>

          <h3 className="text-xl font-semibold text-indigo-600">
            6. COMPENSATION
          </h3>

          <ul className="list-disc pl-6 space-y-2">
            <li>
              Listernaut Software Licenses: $29, $49, $99, or $299/month depending on
              version, plus additional token usage fees beyond allocation.
            </li>
            <li>
              Listernaut Managed Services: $999/month, may downgrade to $299 after
              Client becomes self-sufficient.
            </li>
            <li>
              Invoices are due within 30 days. Contractor may review data for billing
              accuracy.
            </li>
          </ul>


          <p>
            If terminated early without Contractor breach, a pro rata portion of services
            rendered will be billed.
          </p>

          <h3 className="text-xl font-semibold text-indigo-600">
            7. INTEREST ON LATE PAYMENTS
          </h3>
          <p>Late payments incur 18% annual interest.</p>

          <h3 className="text-xl font-semibold text-indigo-600">
            8. CONFIDENTIALITY
          </h3>

          <p>
            The Contractor will not disclose client proprietary information, during or after
            the Term, except as authorized or required by law.
          </p>

          <h3 className="text-xl font-semibold text-indigo-600">
            9. OWNERSHIP OF INTELLECTUAL PROPERTY
          </h3>

          <p>
            All software, intellectual property, and related materials created under this
            Agreement belong to the Contractor. The Client receives a limited-use license.
            Software may not be reverse-engineered or modified.
          </p>

          <h3 className="text-xl font-semibold text-indigo-600">
            10. RETURN OF PROPERTY
          </h3>
          <p>
            Upon termination, Contractor will return all Client property and documents.
          </p>

          <h3 className="text-xl font-semibold text-indigo-600">
            11. INDEPENDENT CONTRACTOR STATUS
          </h3>

          <p>
            The Contractor is not an employee. The Contractor is responsible for all taxes
            and legal filings associated with compensation.
          </p>

          <h3 className="text-xl font-semibold text-indigo-600">
            12. RIGHT OF SUBSTITUTION
          </h3>

          <p>
            The Contractor may hire subcontractors at its discretion. Subcontractors act as
            agents of the Contractor.
          </p>

          <h3 className="text-xl font-semibold text-indigo-600">
            13. AUTONOMY
          </h3>

          <p>
            The Contractor maintains full control over work methods, timing, and decisions.
          </p>

          <h3 className="text-xl font-semibold text-indigo-600">
            14. EQUIPMENT
          </h3>
          <p>
            The Contractor will provide all equipment and tools necessary to deliver the
            Services.
          </p>

          <h3 className="text-xl font-semibold text-indigo-600">
            15. NO EXCLUSIVITY
          </h3>

          <p>
            This Agreement is non-exclusive; both Parties may work with third parties.
          </p>

          <h3 className="text-xl font-semibold text-indigo-600">
            16. NOTICE
          </h3>

          <p>
            Notices will be sent to the Client’s email on file and to Listernaut, LLC, 2457
            East Washington St, Ste D, Indianapolis, IN 46201.
          </p>

          <h3 className="text-xl font-semibold text-indigo-600">
            17. INDEMNIFICATION
          </h3>

          <p>
            Both Parties agree to indemnify and hold the other harmless against claims or
            damages arising from their actions.
          </p>

          <h3 className="text-xl font-semibold text-indigo-600">
            18. MODIFICATION OF AGREEMENT
          </h3>

          <p>
            Any modification must be in writing and signed by both Parties.
          </p>

          <h3 className="text-xl font-semibold text-indigo-600">
            19. TIME OF THE ESSENCE
          </h3>

          <p>Time is of the essence in this Agreement.</p>

          <h3 className="text-xl font-semibold text-indigo-600">
            20. ASSIGNMENT
          </h3>

          <p>
            The Contractor may not assign obligations without written consent.
          </p>

          <h3 className="text-xl font-semibold text-indigo-600">
            21. ENTIRE AGREEMENT
          </h3>

          <p>
            This Agreement constitutes the entire understanding between the Parties.
          </p>

          <h3 className="text-xl font-semibold text-indigo-600">
            22. GOVERNING LAW
          </h3>

          <p>This Agreement is governed by Indiana law.</p>

          <h3 className="text-xl font-semibold text-indigo-600">
            23. SEVERABILITY
          </h3>

          <p>
            If any part is invalid, the remainder stays enforceable.
          </p>

          <h3 className="text-xl font-semibold text-indigo-600">
            24. WAIVER
          </h3>

          <p>
            Waiving a breach does not waive future breaches.
          </p>

          <p>
            IN WITNESS WHEREOF the Parties have electronically accepted this Agreement.
          </p>
        </section>
        {/* --- END SOFTWARE AGREEMENT --- */}

        <footer className="text-center text-gray-500 text-sm mt-8 pt-4 border-t border-gray-200">
          © {new Date().getFullYear()} Listernaut, LLC. All Rights Reserved.
        </footer>
      </div>
    </div>
  );
};

export default TermsAndConditions;
